import React, { Children } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { articles } from '../data/articles';
import { ArticleCard } from './ArticleCard';
interface FeaturedArticlesProps {
  limit?: number;
  showViewAll?: boolean;
}
export function FeaturedArticles({
  limit = 3,
  showViewAll = true
}: FeaturedArticlesProps) {
  const featured = articles.slice(0, limit);
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section id="artikel" className="py-20 bg-white" data-id="element-118">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-119">
        <div className="mb-12 text-center md:text-left" data-id="element-120">
          <div className="inline-block w-12 h-1 bg-vita-orange rounded-full mb-4" data-id="element-121"></div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-vita-green-deep" data-id="element-122">
            Beliebte Artikel
          </h2>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-123">
          {featured.map((article, index) => <motion.div key={article.slug} variants={cardVariants} data-id="element-124">
              <ArticleCard article={article} index={index} className="h-full" data-id="element-125" />
            </motion.div>)}
        </motion.div>

        {showViewAll && <div className="mt-12 text-center" data-id="element-126">
            <Link to="/artikel" className="inline-flex items-center text-vita-green-deep hover:text-vita-orange font-medium transition-colors duration-200 group" data-id="element-127">
              Alle Artikel ansehen
              <svg className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform duration-200" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-128">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" data-id="element-129" />
              </svg>
            </Link>
          </div>}
      </div>
    </section>;
}